import CharaOption from '@/ts/model/CharaOption'

const options = [

  new CharaOption({
    type: 'hair',
    name: 'Hair1',
    dispName: '髪型1',
    thumbPath: '/img/main/thumb/hr1.png',
    imgPath: [
      '/img/main/chara_hr1fr.png',
      '/img/main/chara_hr1bk.png',
      '/img/main/chara_hr1er.png'
    ]
  }),

  new CharaOption({
    type: 'hair',
    name: 'Hair2',
    dispName: '髪型2',
    thumbPath: '/img/main/thumb/hr2.png',
    imgPath: [
      '/img/main/chara_hr2fr.png',
      '/img/main/chara_hr2bk.png',
      '/img/main/chara_hr2er.png'
    ]
  }),

  new CharaOption({
    type: 'hair',
    name: 'Hair3',
    dispName: '髪型3',
    thumbPath: '/img/main/thumb/hr3.png',
    imgPath: [
      '/img/main/chara_hr3fr.png',
      '/img/main/chara_hr3bk.png',
      '/img/main/chara_hr3er.png'
    ]
  }),

  new CharaOption({
    type: 'hair',
    name: 'Hair4',
    dispName: '髪型4',
    thumbPath: '/img/main/thumb/hr4.png',
    imgPath: [
      '/img/main/chara_hr4fr.png',
      '',
      '/img/main/chara_hr4er.png'
    ]
  }),

  new CharaOption({
    type: 'face',
    name: 'Face1',
    imgPath: [
      '/img/main/chara_fc1.png'
    ]
  }),

  new CharaOption({
    type: 'body',
    name: 'Body',
    imgPath: [
      '/img/main/chara_bd1.png'
    ]
  }),

  new CharaOption({
    type: 'dress',
    name: 'Dress1',
    dispName: '赤ワンピ',
    thumbPath: '/img/main/thumb/dress1.png',
    imgPath: [
      '/img/main/chara_dress1.png'
    ]
  }),

  new CharaOption({
    type: 'dress',
    name: 'Dress2',
    dispName: 'エプロン',
    thumbPath: '/img/main/thumb/dress2.png',
    imgPath: [
      '/img/main/chara_dress2.png'
    ]
  }),

  new CharaOption({
    type: 'dress',
    name: 'Dress3',
    dispName: '白ワンピ',
    thumbPath: '/img/main/thumb/dress3.png',
    imgPath: [
      '/img/main/chara_dress3.png'
    ]
  }),

  new CharaOption({
    type: 'dress',
    name: 'Dress4',
    dispName: '黒ワンピ',
    thumbPath: '/img/main/thumb/dress4.png',
    imgPath: [
      '/img/main/chara_dress4.png'
    ]
  })
]

const defs: {[key: string]: CharaOption} = {}
options.forEach(op => { defs[op.name] = op })

export default defs
